import './CurrencyIcon.sass';

import React, { FC, useCallback, useMemo } from 'react';
import { IcBitcoin40, IcToncoin40, IcUsdt40 } from '$assets';

export const CurrencyIcon: FC<{ currency: string }> = ({ currency }) => {
  const icon = useMemo(() => {
    switch (currency.toUpperCase()) {
      case 'BTC':
        return <IcBitcoin40 />;
      case 'TON':
        return <IcToncoin40 />;
      case 'USDT':
        return <IcUsdt40 />;
      default:
        return null;
    }
  }, [currency]);

  return (
    <div title={currency} className="CurrencyIcon">
      {icon}
    </div>
  );
};
